import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

export const answerTypeOptions = {
  text: "topicPartQuestion.answerType.text",
  singleChoice: "topicPartQuestion.answerType.singleChoice",
  multipleChoice: "topicPartQuestion.answerType.multipleChoice",
  yesNo: "topicPartQuestion.answerType.yesNo",
  yesNoUnknown: "topicPartQuestion.answerType.yesNoUnknown",
};

const topicPartQuestionFormConfig: FormConfig[] = [
  {
    name: "text",
    label: "topicPartQuestion.field.text",
    placeholder: "topicPartQuestion.field.textPlaceholder",
    type: FormFieldType.Textarea,
  },
  {
    name: "answerType",
    label: "topicPartQuestion.field.answerType",
    type: FormFieldType.Select,
    settings: {
      options: answerTypeOptions,
    },
  },
  {
    name: "answers",
    label: "topicPartQuestion.field.answers",
    type: FormFieldType.List,
    settings: {
      show: {
        when: "answerType",
        is: ["multipleChoice", "singleChoice"],
      },
    },
  },
  {
    name: "comments",
    label: "topicPartQuestion.field.comments",
    placeholder: "",
    type: FormFieldType.Textarea,
  },
];

export default topicPartQuestionFormConfig;
